import { LitElement, html } from '@lit'

class NovaImageWithText extends LitElement {
  connectedCallback() {
    super.connectedCallback()

    this.$carousel = this.querySelector('.image-with-text-carousel')
    this.$prevButtons = this.querySelectorAll('[prev--button]')
    this.$nextButtons = this.querySelectorAll('[next--button]')
    
    for (const item of this.$prevButtons) {
      item.addEventListener('click', () => this.$carousel.previous())
    }

    for (const item of this.$nextButtons) {
      item.addEventListener('click', () => this.$carousel.next())
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    for (const item of this.$prevButtons) {
      item.removeEventListener('click', () => this.$carousel.previous())
    }

    for (const item of this.$nextButtons) {
      item.removeEventListener('click', () => this.$carousel.next())
    }
  }

  render() {
    return html`
      <slot></slot>
    `
  }
}

customElements.define('nova-image-with-text', NovaImageWithText)
